import React, { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { Formik } from "formik";
import { useSnackbar } from "notistack";

import useSignUp from "./useSignUp";
import SignUpBase from "./SignUpBase";
import withSnackbarRefProvider from "../../../common/components/notification/withSnackbarRefProvider";

const SITE_KEY = "0x4AAAAAABiEWQSAJcU-KwJm"; // Replace with your real site key

const SignUp = () => {
  const router = useRouter();
  const { enqueueSnackbar } = useSnackbar();
  const turnstileRef = useRef<HTMLDivElement | null>(null);
  const [cfToken, setCfToken] = useState("");

  const email = router?.query?.email as string;

  const {
    initialState,
    handleSubmit: originalHandleSubmit,
    signupFormFields,
    validationSchema,
  } = useSignUp((router?.query.next as string) || undefined);

  const initialValues = {
    ...initialState,
    email: !!email ? email.replace(" ", "+") : "",
  };

  signupFormFields[0].disabled = !!email;

  useEffect(() => {
    if (email) {
      enqueueSnackbar(
        `Please sign up with an invited email(${email}) to accept an invitation`,
        {
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "info",
          persist: true,
        }
      );
    }
  }, [email, enqueueSnackbar]);

  useEffect(() => {
    const scriptId = "cf-turnstile-script";

    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
      script.async = true;
      script.defer = true;
      script.onload = () => {
        if ((window as any).turnstile) {
          (window as any).turnstile.render("#cf-turnstile", {
            sitekey: SITE_KEY,
            callback: (token: string) => setCfToken(token),
          });
        }
      };
      document.body.appendChild(script);
    } else {
      if ((window as any).turnstile && turnstileRef.current) {
        (window as any).turnstile.render("#cf-turnstile", {
          sitekey: SITE_KEY,
          callback: (token: string) => setCfToken(token),
        });
      }
    }
  }, []);

  const handleSubmit = (values: any, actions: any) => {
    if (!cfToken) {
      enqueueSnackbar("Please complete the human verification (CAPTCHA).", {
        variant: "error",
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      actions.setSubmitting(false);
      return;
    }

    // Add Turnstile token to values or modify as needed for your API call
    originalHandleSubmit(
      {
        ...values,
        "cf_turnstile_response": cfToken,
      },
      actions
    );
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <>
          <SignUpBase
            signupFormFields={signupFormFields}
            isSubmitting={isSubmitting}
          />
          {/* Mount Turnstile widget */}
          <div
            id="cf-turnstile"
            ref={turnstileRef}
            style={{ marginTop: "24px" }}
          />
        </>
      )}
    </Formik>
  );
};

export default withSnackbarRefProvider(SignUp);
